import "./ticket.css";
import {homeHippodrome, tipstersData, todayResults} from "../../../store/misc.store";
import {useBulletin, useHippodromesMap} from "features/bulletin/bulletin.store";
import {BettingTypesMap} from "../../../features/core/definitions";
import {restoreMutualCoupon} from "../../../features/betslip/mutual.service";
import {useNavigate} from "react-router-dom";
import paths from "../../../paths";
import {buildMutualBettingSubTypes, buildMutualBettingTypes} from "../../../features/bulletin/bulletin.service";
import {showClosedTicketModal, showReplayErrorModal} from "../../betting/replay-error";
import React, {useState} from "react";
import eyeOpen from "../../../assets/icons/eye-line.svg"
import eyeOff from "../../../assets/icons/eye-off-line.svg"

export function Ticket(props: any) {
    const HippodromesMap = useHippodromesMap();
    const bulletin = useBulletin();
    const navigate = useNavigate();
    let selectedHippodrome = props.hippodrome !== undefined ? props.hippodrome : homeHippodrome;
    let ticket = props.ticket;
    let playableTicketTypes: any = [];
    let availableTypes = buildMutualBettingTypes(selectedHippodrome);
    let myRuns: any = [];
    const [openLegs, setOpenLegs] = useState<any>(false);


    for (let i = 0; i < BettingTypesMap[ticket.bet_type].column; i++) {
        myRuns.push(i + Number(ticket.race_id));
    }
    for (const availableType of availableTypes) {
        if (!!!BettingTypesMap[Number(availableType.id)]?.isFob) {
            let availableSubTypes = buildMutualBettingSubTypes(availableType);
            for (const availableSubType of availableSubTypes) {
                if (myRuns.join(",").includes(availableSubType.label.split('-').join(","))) {
                    if (availableType.columnLabel !== 'At') {
                        availableSubType.betType = availableType;
                        playableTicketTypes.push(availableSubType);
                    }
                }
            }
        }

    }


    const playTicket = (ticket: any) => {
        const cardHippodrome = bulletin[selectedHippodrome._id] ?? selectedHippodrome;
        const betType = cardHippodrome?.wager_details?.find(
            (w: any) => Number(w.type) === Number(ticket.bet_type)
        );

        if (!betType || !betType.runs.includes(ticket.race_id)) {
            showClosedTicketModal();
            return;
        }

        try {
            restoreMutualCoupon(cardHippodrome, ticket);
        } catch (error: any) {
            showReplayErrorModal(error?.message ?? "Kupon yüklenemedi.");
            return;
        }

        navigate(`${paths.betting.url}/${selectedHippodrome.keyword.toLowerCase()}${selectedHippodrome._id}`);
    };

    return (
        <>
            <div className="ticket-widget" key={ticket.id}>
                <div className="header d-flex align-items-center justify-content-between">
                    <div className={"d-flex"}>
                        <img
                            className="avatar"
                            src={tipstersData[ticket.member_id]?.avatar || "/assets/tipster/default_avatar_tipster_at_yarisi.png"}
                            alt=""
                        />
                        <div className={"d-flex flex-column justify-content-start align-items-start"}>
                            <h3>
                                {tipstersData[ticket.member_id]?.nick_name ??
                                    `${tipstersData[ticket.member_id]?.first_name} ${tipstersData[ticket.member_id]?.last_name}`}
                            </h3>
                            <span className={"tipster-info"}>Uzman Yazar</span>
                        </div>
                    </div>
                </div>
                <div className="body">
                    <div className="d-flex align-items-center justify-content-between">
                        <div className={"d-flex"}>
                            <span
                                className="bet-info">{HippodromesMap[String(ticket.card).split("-")[1]?.toLowerCase()]?.YER} {BettingTypesMap[Number(ticket.bet_type)]?.shortName ?? BettingTypesMap[Number(ticket.bet_type)]?.name}</span>
                        </div>
                        <div className={"d-flex flex-column align-items-end"}>
                            <div className={"ticket-open"} onClick={() => {
                                setOpenLegs(!openLegs)
                            }}>
                                {openLegs ? 'Gizle' : 'Göster'} <img src={openLegs ? eyeOff : eyeOpen}/>
                            </div>
                        </div>
                    </div>
                    <div className={"ticket-info row"}>
                        <div className={"ticket-info-box col-4"}>
                            Bahis: <b>{ticket.bet_count}</b>
                        </div>
                        <div className={"ticket-info-box col-4"}>
                            Misli: <b>{ticket.multiply}</b>
                        </div>
                        <div className={"ticket-info-box col-4"}>
                            Tutar: <b>{ticket.amount}</b>
                        </div>
                    </div>

                    {openLegs && <div className={"legs flex-column"}>
                        {ticket.legs.map((run: any, legIndex: number) => {
                            return <div
                                className={`run d-flex align-items-center ${bulletin[selectedHippodrome._id]?.runsMap[ticket.race_id + legIndex]?.status === 0 ? "" : "disabled"}`}
                                key={`legIndex-${legIndex}`}>
                                <div style={{marginRight: "4px"}}>
                                    {BettingTypesMap[Number(ticket.bet_type)].columnLabel !== "At"
                                        ? ticket.race_id + legIndex
                                        : legIndex + 1}
                                    .{BettingTypesMap[Number(ticket.bet_type)].columnLabel !== "At" ? 'Koşu' : 'At'}:
                                </div>
                                {run.map((horse: any, horseIndex: number) => {
                                    let isWinner = false;
                                    try {
                                        isWinner = todayResults[selectedHippodrome.keyword].runsMap[BettingTypesMap[Number(ticket.bet_type)].columnLabel !== "At" ? ticket.race_id + legIndex : legIndex + 1]?.winnerHorse.no.toString() === horse.toString()
                                        if (!!BettingTypesMap[Number(ticket.bet_type)]?.isStablemateWins && !isWinner) {
                                            if (todayResults[selectedHippodrome.keyword].runsMap[BettingTypesMap[Number(ticket.bet_type)].columnLabel !== "At" ? ticket.race_id + legIndex : legIndex + 1]?.winnerStablemate) {
                                                for (const horseElement of todayResults[selectedHippodrome.keyword].runsMap[BettingTypesMap[Number(ticket.bet_type)].columnLabel !== "At" ? ticket.race_id + legIndex : legIndex + 1]?.winnerStablemate) {
                                                    isWinner = horseElement.no.toString() === horse.toString()
                                                }
                                            }

                                        }
                                    } catch (e) {
                                        console.error(e);
                                    }

                                    return <span className={`${isWinner ? 'text-danger fw-bold' : ''}`}
                                                 key={`horseIndex-${horseIndex}`}>{horse}{horseIndex < run.length - 1 ? ', ' : ''} </span>
                                })}
                            </div>
                        })}

                    </div>}
                </div>
                <div className="footer">
                    <div
                        className={`status cursor-pointer ${playableTicketTypes.length > 0 ? "" : "disabled"} `}
                        onClick={() => {
                            if (playableTicketTypes.length > 0) {
                                playTicket(ticket);
                            }
                        }}>
                        Kupon Oyna
                    </div>
                </div>
            </div>
        </>
    );
}
